import React, { useState, useCallback } from 'react'
import { ActionElement } from 'react-querybuilder'
import { FaTimes } from 'react-icons/fa'
import ConfirmationModal from '../../../../../features/reporting/ConfirmationModal'

export const AddRuleActionElement = props => {
    if (props.context && props.context.viewOnly) {
        return null
    }
    return (
        <ActionElement
            {...props}
            className='ruleGroup-addRule button is-info'
            label={'+ Column'}
            title={'Add Column'}
        />
    )
}

export const RemoveRuleAction = props => {
    const { context, handleOnClick } = props
    const [showConfirmation, setShowConfirmation] = useState(false)

    const {
        deleteRuleClassName = 'delete-button',
        showRuleDeleteConfirmation = true,
    } = context || {}

    const handleDelete = useCallback(() => {
        if (handleOnClick) {
            handleOnClick()
        }
        setShowConfirmation(false)
    }, [handleOnClick])

    const handleClick = useCallback(() => {
        if (showRuleDeleteConfirmation) {
            setShowConfirmation(true)
        } else {
            handleDelete()
        }
    }, [showRuleDeleteConfirmation, handleDelete])

    if (context?.viewOnly) return null

    return (
        <>
            <div
                className={`${deleteRuleClassName}`}
                style={{
                    visibility:
                        props.ruleOrGroup &&
                        props.ruleOrGroup.path &&
                        props.ruleOrGroup.path[0] === 0
                            ? 'collapse'
                            : 'visible',
                }}
                title={`Delete Column Join`}
                onClick={handleClick}
            >
                <span className='icon' style={{ marginTop: 8 }}>
                    <FaTimes />
                </span>
            </div>
            {showRuleDeleteConfirmation && (
                <ConfirmationModal
                    display={showConfirmation}
                    title={'Delete Column Join Confirmation'}
                    confirmAction={handleDelete}
                    confirmText={`Delete`}
                    denyAction={() => {
                        setShowConfirmation(false)
                    }}
                    denyText={`Cancel`}
                >
                    <p>Are you sure you want to delete this column join?</p>
                </ConfirmationModal>
            )}
        </>
    )
}
